// types
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import { NavItemType } from 'types/menu';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import PhoneIcon from '@mui/icons-material/Phone';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { PERMISSIONS } from 'contexts/PermissionContext';
// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [
    {
      id: 'other',
      title: 'Others',
      type: 'group',
      children: [
        {
          id: 'dashboard',
          title: 'Priority',
          type: 'item',
          url: '/',
          icon: SpaceDashboardOutlinedIcon,
          iconProps: { sx: { transform: 'rotate(360deg)' } },
          permission: PERMISSIONS.DASHBOARD_PAGE_ACCESS
        },
        {
          id: 'dashboard-analytics',
          title: 'Analytics',
          type: 'item',
          url: '/dashboard-analytics',
          icon: BarChartOutlinedIcon,
          permission: PERMISSIONS.ANALYTICS_PAGE_ACCESS
        },
        {
          id: 'Transactions',
          title: 'Transactions',
          type: 'item',
          url: '/transactions',
          icon: FormatListBulletedIcon
        },
        {
          id: 'clients',
          title: 'Clients',
          type: 'item',
          url: '/clients',
          icon: AccountCircleOutlinedIcon,
          permission: PERMISSIONS.CLIENT_PAGE_ACCESS
        },
        {
          id: 'users',
          title: 'Users',
          type: 'item',
          url: '/users',
          icon: PeopleOutlinedIcon
        },
        {
          id: 'Processes',
          title: 'Processes',
          type: 'item',
          url: '/teams',
          icon: AccountTreeOutlinedIcon
        },

        {
          id: 'resources',
          title: 'Resources',
          type: 'item',
          url: '/resources',
          icon: FolderOpenOutlinedIcon
        },
        {
          id: 'missed-calls',
          title: 'Calls',
          type: 'item',
          url: '/missed-calls',
          icon: PhoneIcon, // You can use another icon if preferred
          permission: PERMISSIONS.CALLS_PAGE_ACCESS
        },
        {
          // Visibility is data-dependent, not permission-based — a client only sees this
          // once an announcement targets them. Gated in Navigation, not by `permission`.
          // `id` stays 'announcements' — Navigation keys the visibility gate and the
          // unread badge off it, and the route and API are unchanged. Only the label moved.
          id: 'announcements',
          // Short label so it sits comfortably in the drawer; the full name is revealed
          // on hover rather than crammed in or truncated to an ellipsis.
          title: 'Updates',
          titleTooltip: 'Update & Training',
          type: 'item',
          url: '/announcements',
          icon: CampaignOutlinedIcon
        },
        {
          id: 'ai-support',
          title: 'Tickets',
          type: 'item',
          url: '/ai-support',
          icon: SupportAgentOutlinedIcon,
          permission: PERMISSIONS.AI_SUPPORT_PAGE_ACCESS
        },
        {
          id: 'help',
          title: 'Help',
          type: 'item',
          url: '/help',
          icon: HelpOutlineOutlinedIcon,
          permission: PERMISSIONS.HELP_PAGE_ACCESS
        }
      ]
    }
  ]
};

export default menuItems;
